import { Component, Input } from '@angular/core';

@Component({
    selector: 'ipp-download-response',
    template: require('./ipp-download-response.component.html')
})
export class IppDownloadResponseComponent{
    @Input() title: string;

    constructor(
    ) {

    }

    downloadResponses() {
        var elHtml = '';
        var textEntryInteractions = document.getElementsByTagName("text-entry-interaction");
        var extendedTextInteractions = document.getElementsByTagName('extended-text-interaction');
        elHtml = this.createTextEntryInteractionOutput(textEntryInteractions, elHtml);
        elHtml = this.createExtendedTextInteractionOutput(extendedTextInteractions, elHtml);
        var link = document.createElement('a');
        link.setAttribute('download', 'my-response.doc');         
        link.setAttribute('href', 'data:' + 'text/doc' + ';charset=utf-8,' + encodeURIComponent(elHtml));
        link.click();
    }

    createTextEntryInteractionOutput(textEntryInteractions: NodeListOf<Element>, elHtml: string): string{
        var i = 0;
        for(i = 0; i < textEntryInteractions.length; i++){
            var textEntryInput = textEntryInteractions[i].children[0];
            if(i == 0){
                var moreThanOneInput = textEntryInteractions.length > 1;
                var addAdditionalInputHeader = moreThanOneInput ? "\nPrompt 2: " : "\n\n";
                elHtml = elHtml + "Prompt 1: " + (<HTMLInputElement>textEntryInput).value + addAdditionalInputHeader;
            }else if(i == textEntryInteractions.length-1){
                elHtml = elHtml + (<HTMLInputElement>textEntryInput).value + "\n\n";
            }else{
                elHtml = elHtml + (<HTMLInputElement>textEntryInput).value + "\nPrompt " + (i + 2) + ": ";
            }    
        }
        return elHtml;
    }

    createExtendedTextInteractionOutput(extendedTextInteractions: NodeListOf<Element>, elHtml: string): string{
        var i = 0;
        for(i = 0; i < extendedTextInteractions.length; i++){
            var extendedTextDiv = extendedTextInteractions[i].getElementsByClassName('extended-text');
            var editorContainer = extendedTextDiv[0].getElementsByClassName('editor-container text-area');
            var element = editorContainer[0];
            if(i == 0){
                var moreThanOneEditorContainer = extendedTextInteractions.length > 1;
                var addAdditionalTextResponseHeader = moreThanOneEditorContainer ? "\n\nShort Response 2:\n\n" : "";
                elHtml = elHtml + "Short Response 1:\n\n" + (<HTMLElement>element).innerText + addAdditionalTextResponseHeader;
            }else if(i == extendedTextInteractions.length-1){
                elHtml = elHtml + (<HTMLElement>element).innerText;
            }else{
                elHtml = elHtml + (<HTMLElement>element).innerText + "\n\nShort Response " + (i + 2) + ":\n\n";
            }    
        }
        return elHtml;
    }
}


// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-download-response/ipp-download-response.component.ts